export enum FileTypeEnum {
    Image,
    Word,
    Excel,
    Powerpoint,
    Other
}